const mockExamSplitName = (fullName: string) => {
  const response: {
    first_name: string;
    last_name: string | null;
  } = {
    first_name: '',
    last_name: '',
  };
  const splitName = fullName.trim().split(' ');
  if (splitName.length === 0) return response;
  else if (splitName.length === 1) {
    response.first_name = splitName[0];
    response.last_name = null;
  } else {
    response.last_name = splitName.pop()!;
    response.first_name = splitName.join(' ');
  }
  return response;
};

export default mockExamSplitName;
